import { useEffect, useState, useRef } from "react";
import "./App.css";
import { ethers } from "ethers";
import { CONTRACT_ADDRESS, CONTRACT_ABI } from "./constants/constants";
import web3Modal from "web3modal";
// import bulbasaur from "../public/bulbasaur.png";
// import bulba from "bulbasaur2.jpg";

function App() {
  const [isConnected, setIsConnected] = useState(false);
  const [account, setAccount] = useState("");
  const [noOfNFTs, setNoOfNFTs] = useState(0);
  const [isOwner, setIsOwner] = useState(false);

  const web3ModalRef = useRef();

  const getProviderOrSigner = async (needSigner = false) => {
    try {
      if (window.ethereum) {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        await provider.send("eth_requestAccounts", []);

        // const { chainId } = await provider.getNetwork();
        const signer = provider.getSigner();

        if (needSigner) {
          return signer;
        }
        return provider;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getOwner = async () => {
    try {
      const provider = await getProviderOrSigner();
      const contract = new ethers.Contract(
        CONTRACT_ADDRESS,
        CONTRACT_ABI,
        provider
      );
      const _owner = await contract.owner();
      const signer = await getProviderOrSigner(true);
      const address = await signer.getAddress();
      console.log(_owner);
      if (address.toLowerCase() === _owner.toLowerCase()) {
        setIsOwner(true);
      } else {
        setIsOwner(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const connectWallet = async () => {
    try {
      const signer = await getProviderOrSigner(true);
      const _account = await signer.getAddress();
      setAccount(_account);
      await getOwner();

      setIsConnected(true);
      console.log(await signer.getChainId());
    } catch (err) {
      console.error(err);
    }
  };

  const AccountButton = () => {
    if (isConnected) {
      return (
        <button className="accountBtn">
          {account.substring(0, 4) + "..." + account.substring(12, 16)}
        </button>
      );
    }
  };

  const getNoOfNFTs = async () => {
    try {
      const provider = await getProviderOrSigner();
      const contract = new ethers.Contract(
        CONTRACT_ADDRESS,
        CONTRACT_ABI,
        provider
      );
      const countBigNum = await contract.getCount();
      const count = countBigNum.toString();

      setNoOfNFTs(count);
      // console.log(count.toString());
    } catch (error) {
      console.log(error);
    }
  };

  const buyNFT = async () => {
    try {
      const signer = await getProviderOrSigner(true);
      const contract = new ethers.Contract(
        CONTRACT_ADDRESS,
        CONTRACT_ABI,
        signer
      );
      const txn = await contract.safeMint(
        "ipfs://QmPi8it6cRZwo5ikD2DMP4haramahjALCawtbrXSHLhn4W",
        {
          value: ethers.utils.parseEther("0.0001"),
        }
      );
      await txn.wait();
      await getNoOfNFTs();
    } catch (error) {
      console.log(error);
    }
  };

  const withdraw = async () => {
    try {
      const signer = await getProviderOrSigner(true);
      const contract = new ethers.Contract(
        CONTRACT_ADDRESS,
        CONTRACT_ABI,
        signer
      );
      const txn = await contract.withdraw(
        "0x83f5ebac3c2806ef448946c19a371076b6a6d0ca"
      );
      await txn.wait();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setInterval(() => {
      getNoOfNFTs();
    }, 10 * 1000);

    if (!isConnected) {
      web3ModalRef.current = new web3Modal({
        network: "goerli",
        providerOptions: {},
        disableInjectedProvider: false,
      });
      // connectWallet();
    }

    window.ethereum?.on("accountsChanged", connectWallet);
    return () => {
      window.ethereum?.removeListener("accountsChanged", connectWallet);
    };
  }, [isConnected]);

  return (
    <div className="App">
      <div className="connect">
        <h1 className="title">BulbaNFT</h1>
        {!isConnected && (
          <button onClick={connectWallet} className="connectBTN">
            Connect Wallet
          </button>
        )}
        {AccountButton()}
      </div>
      <div className="landing-page">
        <div className="hero-text">
          <p className="description">
            Collect your <span>Bulbasaur</span> NFT
          </p>
          <p className="number">
            Number of NFTs minted : <span>{noOfNFTs}</span>
          </p>
          <button onClick={buyNFT} className="buyBtn">
            Mint NFT
          </button>

          {isOwner && (
            <button onClick={withdraw} className="withdrawBtn">
              Withdraw
            </button>
          )}
        </div>
        <div className="hero-image">
          <img
            src="bulbasaur2.jpg"
            alt="image"
            width={300}
            className="hero-img"
          />
        </div>
      </div>
    </div>
  );
}

export default App;
